<template>
  <div id="container" class="library_st_detail">
    <!-- Location START -->
    <div class="location_wrap">
      <div class="location">
        <button type="button" class="btn_open_snb">
          {{ $t('views.store.enotedetail.9101') }}
        </button>
        <span>{{ $t('views.store.enotedetail.8699') }}</span>
        <span class="svg_next">></span>
        <span>노트</span>
        <span class="svg_next">></span>
        <div class="current">
          <div class="select_area">
            <div class="select_item">
              <button type="button" class="select_option">
                <span class="txt">{{ $t('views.store.enotedetail.8783') }}</span
                ><span class="arrow blind">열기</span>
              </button>
              <ul class="select_list">
                <li>
                  <a href="javascript:void(0)">{{
                    $t('views.store.enotedetail.1839')
                  }}</a>
                </li>
                <li>
                  <a href="javascript:void(0)">{{
                    $t('views.store.enotedetail.1536')
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <span class="svg_next">></span>
        <span>{{ $t('views.store.enotedetail.9277') }}</span>
      </div>
    </div>
    <!-- Location END -->

    <!-- 도서 기본 정보 -->
    <div class="section full">
      <div class="inner">
        <div class="detail_book">
          <div class="eplist note">
            <div>
              <div class="cover_wrap" :class="{ best: enote.isBest }">
                <div class="thum_wrap">
                  <img :src="enote.img" :alt="enote.title" />
                </div>
              </div>
            </div>
            <div>
              <div class="info_wrap">
                <div class="row">
                  <h3 class="meta_title">{{ enote.title }}</h3>
                  <p class="meta_author">
                    {{ enote.author }}
                  </p>
                  <p class="meta_publisher">{{ enote.publisher }}</p>
                  <p class="meta_date">{{ enote.releaseDate }}</p>

                  <p class="meta_rate">
                    <span class="score_wrap">
                      <StarRating
                        class="star_rating"
                        :rating="enote.rating"
                        active-color="#FFC515"
                        :star-size="starSize"
                        :increment="increment"
                        :show-rating="showRating"
                        :read-only="readOnly"
                      />
                      <span class="score_score">{{ enote.rating }}</span
                      ><span class="blind">{{ $t('common.ui.rating') }}</span>
                      <span class="score_count_w">
                        (<span class="score_count">
                          {{ enote.reviewCount }}
                        </span>
                        )<span class="blind">{{
                          $t('common.ui.people')
                        }}</span></span
                      >
                    </span>
                  </p>

                  <div class="meta_detail">
                    <!-- TODO: Should link to the relative book store page -->
                    <router-link
                      :to="{ name: 'book_detail', params: 'id' }"
                      class="box_btn link_book"
                      ><span class="an_t">{{
                        $t('views.store.enotedetail.4391')
                      }}</span></router-link
                    >
                    <dl>
                      <!-- <dt>{{ $t('views.store.enotedetail.2662') }}</dt>
											<dd>{{ $t('views.store.enotedetail.7200') }}</dd> -->
                      <dt>{{ $t('views.store.enotedetail.6598') }}</dt>
                      <dd>{{ enote.lastEdited }}</dd>
                      <dt>{{ $t('views.store.enotedetail.5863') }}</dt>
                      <dd>{{ enote.lastOpened }}</dd>
                    </dl>
                  </div>
                </div>
              </div>

              <div class="btn_wrap">
                <div class="bdsi_f2">
                  <!-- 모바일 모드 일때는 bdsi_f2 -> bdsi_f0 으로 클래스 변경 됨 -->
                  <a class="box_btn dull" @click="requestShare"
                    ><span class="an_t">{{
                      $t('views.store.enotedetail.2585')
                    }}</span></a
                  >
                </div>
                <div class="bdsi_f2">
                  <!-- TODO: @Stan this should open the current enote in the Ealice viewer and pass the ID to the relative book -->
                  <a class="box_btn" @click="openInViewer"
                    ><span class="an_t">{{
                      $t('views.store.enotedetail.31')
                    }}</span></a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 이 작성자의 인기 노트 -->
    <div class="section fill pb">
      <div class="inner">
        <div class="graybox">
          <h2>
            <span class="sec_title min"
              ><span>{{ $t('views.store.enotedetail.2466') }}</span></span
            >
          </h2>
          <div class="eplist item_columns_6 note">
            <ul class="item_list">
              <li v-for="(note, idx) in enotes" :key="idx">
                <div class="cover_wrap best">
                  <router-link
                    :to="{ name: 'enote_detail', params: 'id' }"
                    class="thum_wrap"
                  >
                    <img :src="note.img" :alt="note.title" />
                  </router-link>
                </div>
                <div class="info_wrap">
                  <p>
                    <span class="meta_author">{{ note.author }}</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 이 작성자의 인기 셀프북 -->
    <div class="section fill">
      <div class="inner">
        <h2>
          <span class="sec_title min"
            ><span>{{ $t('views.store.enotedetail.320') }}</span></span
          >
        </h2>
        <div class="eplist item_columns_6 sbook">
          <ul class="item_list">
            <li>
              <div class="cover_wrap">
                <router-link
                  :to="{ name: 'selfbook_detail', params: '' }"
                  class="thum_wrap"
                  data-bg-color="blue"
                >
                  <span class="meta_title">{{ selfbook.title }}</span>
                </router-link>
              </div>
              <div class="info_wrap">
                <h3 class="meta_title">{{ selfbook.title }}</h3>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Review List START -->
    <ReviewBox :book="reviews" />
  </div>
</template>

<script>
import ReviewBox from '@/components/library/ReviewBox.vue'
import StarRating from 'vue-star-rating'

export default {
  name: 'EnoteDetail',

  components: { ReviewBox, StarRating },

  data() {
    return {
      // STAR RATING
      starSize: 16,
      increment: 0.5,
      showRating: false,
      readOnly: true,

      // BookHead
      // enote: {
      //   title: '세계의 몸짓',
      //   img: require('@/assets/images/cover/temp_book_cover1.jpg'),
      //   author: '권경애, 김형래, 박경은',
      //   releastDate: '2016.05.28',
      //   rating: 3.7,
      //   reviewCount: 79,
      //   publisher: '한국외국어대학교 지식출판원',
      //   lastEdited: '2020.02.16',
      //   lastOpened: '2020.02.15',
      //   isBest: true
      // },
      // 이 작성자의 인기 노트
      // enotes: [
      //   {
      //     title: '세계의 몸짓',
      //     img: require('@/assets/images/cover/temp_book_cover1.jpg'),
      //     author: '이지은',
      //     releastDate: '2016.05.28',
      //     rating: 3.7,
      //     reviewCount: 79,
      //     publisher: '한국외국어대학교 지식출판원',
      //     lastEdited: '2020.02.16',
      //     lastOpened: '2020.02.15',
      //     isBest: true
      //   }
      // ],
      // selfbook: {
      //   title: '세계의 몸짓',
      //   img: require('@/assets/images/cover/temp_book_cover1.jpg')
      // },
      reviews: [
        {
          text: 'this is a test review from props',
          // Should be shortened to 3 characters, with remaining chars after 3 = ****
          reviewer: 'username',
          rating: 4,
          purchased: false,
          upVotes: 55,
          downVotes: 10,
          shared: true,
          // Status can = 'editing' (비공개), 'purchased' (구매), 'notPurchased' (비구매)
          status: 'purchased'
        },
        {
          text: 'this is a test review from props',
          // Should be shortened to 3 characters, with remaining chars after 3 = ****
          reviewer: 'notCreator',
          rating: 4,
          purchased: true,
          upVotes: 55,
          downVotes: 10,
          shared: true,
          // Status can = 'editing' (비공개), 'purchased' (구매), 'notPurchased' (비구매)
          status: 'purchased'
        },
        {
          text: 'this is a test review from props',
          // Should be shortened to 3 characters, with remaining chars after 3 = ****
          reviewer: 'notCreator',
          rating: 4,
          purchased: false,
          upVotes: 55,
          downVotes: 10,
          shared: true,
          // Status can = 'editing' (비공개), 'purchased' (구매), 'notPurchased' (비구매)
          status: 'purchased'
        }
      ]
    }
  },

  methods: {
    requestShare() {
      // request owner to share this eNote
    },
    openInViewer() {
      // OPEN THIS eNote IN VIEWER
    }
  }
}
</script>

<style lang="scss" scoped>
.vue-star-rating {
  width: 90px;
  float: left;
  top: 2px;
  position: relative !important;
}

.meta_rate {
  margin-top: 4px !important;
}
</style>
